import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import YellowDivider from "../../components/dividers/YellowDivider";
import ArticleBody from "../../components/article/ArticleBody";
import ArticleInfo from "../../components/article/ArticleInfo";
import {
  getCafeMediaBySlug,
  getLocalisedCafeMediaByParentId,
} from "../../api/cafe";
import "../../stylesheet/components/media/MediaMain.scss";
import FeaturedCafeContent from "../../components/contentpreview/FeaturedCafeContent";
import { Media } from "../../compilers/media";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ArticleInner: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [media, setMedia] = useState<Media>();
  const [loading, setLoading] = useState<boolean>(true);
  const { t, i18n } = useTranslation();
  const history = useHistory();

  function getLanguage() {
    const url = location.pathname.split("/");
    return url[1];
  }

  useEffect(() => {
    const lang = getLanguage();
    getCafeMediaBySlug(lang, slug).then((response: Media) => {
      if (response == undefined) {
        history.replace(`/${i18n.language}/404`);
      } else {
        setMedia(response);
        setLoading(false);
      }
    });
  }, [slug]);

  useEffect(() => {
    if (media) {
      setLoading(true);
      getLocalisedCafeMediaByParentId(i18n.language, media.data.parent_id)
        .then((response: Media) => {
          history.replace(
            `/${i18n.language}/cafe/catalogue/${response.data.slug}`
          );

          setMedia(response);
          setLoading(false);
        })
        .catch((error) => {
          history.replace(`/${i18n.language}/404`);
          console.log(error);
        });
    }
  }, [i18n.language]);

  if (loading) {
    return (
      <div className="pt-4" style={{ minHeight: "90vh" }}>
        <div className="container main cafe-page">
          <h1 style={{ width: "20vw" }}>
            <Skeleton />
          </h1>
          <YellowDivider heading="h2" />
          <div className="media-inner-section">
            <div className="media-body">
              <Skeleton height={450} style={{ marginBottom: "20px" }} />
              <Skeleton count={20} />
            </div>
            <div className="media-inner-info">
              <div className="info-divider" />
              <Skeleton height={30} width={100} />
              <Skeleton width={150} style={{ marginBottom: "20px" }} />
              <Skeleton height={30} width={100} />
              <Skeleton width={150} style={{ marginBottom: "20px" }} />
              <Skeleton height={30} width={100} />
              <Skeleton width={150} style={{ marginBottom: "20px" }} />
              <Skeleton height={30} width={100} />
              <Skeleton width={150} style={{ marginBottom: "20px" }} />
              <Skeleton height={30} width={100} />
            </div>
          </div>
          <div>
            <Skeleton />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-4">
      <div className="container main cafe-page">
        <div className="hidden-mobile article-title-container">
          <h1 className="h2">{media.data.title}</h1>
          <YellowDivider heading="h1" />
        </div>
        <div className="media-inner-section">
          <ArticleBody media={media} />
          <ArticleInfo className="hidden-mobile" media={media} />
        </div>
        <FeaturedCafeContent
          title={t("inner-page.latest-articles")}
          smallTitle={true}
          linkTitle={t("zecafe-titlecard-articles.link-title")}
          link={`/${i18n.language}/cafe/catalogue`}
        />
      </div>
    </div>
  );
};

export default ArticleInner;
